/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'


const CustomDropdown = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        setIsLoading(false)
    }, [])

    const handleSelect = (e, data) => {
        setFieldValue(name, data.value)
    }


    let options = props.filteredOptions;

    return (
        <>
            <Dropdown
                search
                selection
                onChange={(e, data) => { handleSelect(e, data) }}
                options={options}
                clearable
                loading={isLoading}
                {...props}
                fluid
            />
        </>
    )
}


export default CustomDropdown;